import { render } from "./RegistrationForm.vue?vue&type=template&id=3d73e268&scoped=true"
import script from "./RegistrationForm.vue?vue&type=script&lang=js"
export * from "./RegistrationForm.vue?vue&type=script&lang=js"

import "./RegistrationForm.vue?vue&type=style&index=0&id=3d73e268&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d73e268"

export default script